import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { trackPageview } from "@/lib/analytics";
import { initSentryClient } from "@/lib/sentry-init";

// Mount once at the root. Initializes Sentry (if DSN present) and fires a
// Plausible pageview on every resolved navigation. Both layers self-gate on
// consent / configuration, so this component is always safe to mount.
export function AnalyticsListener() {
  const router = useRouter();

  useEffect(() => {
    initSentryClient();
    // Initial pageview (router subscribe only fires on subsequent navigations).
    trackPageview();
    const unsub = router.subscribe("onResolved", () => {
      trackPageview();
    });
    return () => {
      unsub();
    };
  }, [router]);

  return null;
}